export const getMargaritas = (t) => [
  {
    id: 'amarilla',
    title: t('Home.Marg1Title'),
    image: t('Home.Marg1Img'),
    imagepop: 'https://snippcheck.blob.core.windows.net/files/Suntory_2008309_HornitosDiadelosMuertos2025/popup-amarilla.jpg',
    bgClass: 'amarilla-bg',
    tintClass: 'amarilla-tint',
    desc: 'Yellow symbolizes light and life. It is often used to represent the fragility of life and the transition between the world of the living and the dead.',
    method: 'Combine ingredients in a cocktail shaker with ice. Shake and strain into a rocks glass over fresh ice.',
    ingredients: '2 parts Hornitos Reposado Tequila<br>1 part fresh lime juice<br>½ part passionfruit syrup',
    glassware: 'Rocks',
    garnish: 'Pineapple wedge & dried marigold'
  },
  {
    id: 'rosa',
    title: t('Home.Marg2Title'),
    image: t('Home.Marg2Img'),
    imagepop: 'https://snippcheck.blob.core.windows.net/files/Suntory_2008309_HornitosDiadelosMuertos2025/popup-rosa.jpg',
    bgClass: 'rosa-bg',
    tintClass: 'rosa-tint',
    desc: 'A more festive hue, pink is used to celebrate happiness and celebration. Dia de los Muertos is not a somber funeral, but a joyous reunion.',
    method: 'Combine ingredients in a cocktail shaker with ice. Shake and strain into a rocks glass over fresh ice.',
    ingredients: '2 parts Hornitos Reposado Tequila<br>1 part fresh lime juice<br>½ part guava syrup',
    glassware: 'Rocks',
    garnish: 'Dried marigold'
  },
  {
    id: 'naranja',
    title: t('Home.Marg3Title'),
    image: t('Home.Marg3Img'),
    imagepop: 'https://snippcheck.blob.core.windows.net/files/Suntory_2008309_HornitosDiadelosMuertos2025/popup-naranja.jpg',
    bgClass: 'naranja-bg',
    tintClass: 'naranja-tint',
    desc: 'Orange symbolizes the sun and light. Its brightness and the scent of marigolds are believed to create a path that guides the spirits back to their family homes.',
    method: 'Combine ingredients in a cocktail shaker with ice. Shake and strain into a rocks glass over fresh ice.',
    ingredients: '2 parts Hornitos Reposado Tequila<br>1 part fresh lime juice<br>½ part tangerine or mandarin syrup',
    glassware: 'Rocks',
    garnish: 'Dried marigold'
  }
];
